export default __webpack_public_path__ + "assets/roboto-v18-latin-regular.5d4aeb4.woff2";